// extracted by mini-css-extract-plugin
module.exports = {"active":"_nav-item-module--active--3axkN","navLi":"_nav-item-module--navLi--2qIM9"};